import { defineStore } from "pinia";
import log from "loglevel";
import { Section } from "@/interfaces/SpinTheWheel/Section";
import { SpinTheWheelService } from "@/api/services/SpinTheWheelService";
import { WheelInitialData } from "@/interfaces/SpinTheWheel/WheelInitialData";
import { WheelStatus } from "@/interfaces/SpinTheWheel/WheelStatus";
import { useAuthStore } from "./AuthStore";

export const SpinTheWheelStore = defineStore('SpinTheWheelStore', {
    state: () => ({
        sections: [] as Section[],
        result: {} as Section,
        activeWheelRewards: [] as Section[],
        wheelStatus: {
            cant_spin: false,
            end_time: 0,
        } as WheelStatus,
    }),
    actions: {
        async initialize() {
            console.log('Initializing SpinTheWheelStore');
            try {
                const authStore = useAuthStore();
                if (authStore.isUserLoggedIn()) {
                    await this.getWheelInitialData();
                    await this.getActiveWheelRewards();
                    console.log('SpinTheWheelStore initialized successfully');
                    return true;
                } else {
                    log.info("User not logged in, skipping SpinTheWheelStore initialization");
                    return true; // Still consider it initialized even if user is not logged in
                }
            } catch (error) {
                log.error("Failed to initialize SpinTheWheelStore:", error);
                return false;
            }
        },
        async getWheelInitialData() {
            try {
                const response: WheelInitialData = await SpinTheWheelService.getWheelInitialData();
                this.sections = response?.wheel_data ?? [];
                this.wheelStatus = response?.wheel_status ?? { cant_spin: false, end_time: 0 } as WheelStatus;
            } catch (error) {
                log.error("Failed to get wheel initial data:", error);
            }
        },
        async getActiveWheelRewards() {
            try {
                const response = await SpinTheWheelService.getActiveWheelRewards();
                this.activeWheelRewards = response ?? [];
            } catch (error) {
                log.error("Failed to get active wheel rewards:", error);
            }
        },
        async getResult() {
            try {
                const response = await SpinTheWheelService.getResult();
                this.result = response ?? {} as Section;
            } catch (error) {
                log.error("Failed to get wheel result:", error);
            }
        }
    },
});